// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--f0a07";
export var headingContainer = "index-module--heading-container--2790b";
export var highlight = "index-module--highlight--c9db9";
export var highlightLine = "index-module--highlight-line--15042";
export var image1 = "index-module--image-1--455c8";
export var image2 = "index-module--image-2--13767";
export var imageContainer = "index-module--image-container--daebd";